<template>  
  <div class="salesmanOrderdetailPage">
    <XR-head titleText="订单详情"></XR-head>
    <div class="order-state" v-if="!loaded" :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
      <p class="state-text">{{orderDetail.StateName}}</p>
    </div>
    <router-link :to="'/salesman/orderdelivery?orderNo='+orderDetail.OrderNo" class="" v-if="orderDetail.DeliveryTracking && orderDetail.DeliveryTracking[0].WuLiu">
      <div class="delivery" v-if="!loaded">
        <div class="leftIcon">
          <i class="fa fa-delivery"></i>
        </div>
        <div class="delivery-process">
          <div class="text">{{ orderDetail.DeliveryTracking[0].WuLiu.data.length>0?orderDetail.DeliveryTracking[0].WuLiu.data[0].context : orderDetail.DeliveryTracking[0].WuLiu.message}}</div>
        </div>
        <div class="rightIcon">
          <i class="fa fa-angle-right"></i>
        </div>
      </div>
    </router-link>
    <div class="order-delivery" v-if="!loaded">
      <div class="mapIcon">
            <img src="/static/icon/address-location.png" />
          </div>
      <div class="delivery-info">
        <div class="member-info">
          <p class="username">{{orderDetail.OrderDelivery.Receiver}}</p>
          <p class="mobile">{{orderDetail.OrderDelivery.Phone}}</p>
        </div>
        <div class="address">{{orderDetail.OrderDelivery.Address}}</div>
      </div>
    </div>

    <div class="order-list" v-if="!loaded">
      <div class="order-item">
        <!-- <div class="shoptip">
          <img class="shop-logo" :src="orderDetail.ShopLogo" />
          <p class="shop-name">{{orderDetail.ShopName}}</p>
          <p class="state"></p>
        </div> -->
        <div class="shopRow">          
            <!-- <div class="all-chk"><mu-checkbox class="cart-all-chk" :nativeValue="cartItem.ShopId" @change="shopClick(cartItem.ShopId)" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-yes"/></div> -->
            <div class="shopName">
              <img :src="orderDetail.ShopLogo" class="shopLogo" />
              <div class="shopNameValue">
                <span>{{orderDetail.ShopName}}</span>
                <i class="fa fa-angle-right"></i>
              </div>
            </div>      
          </div> 
        <div class="hidden-scorll">
          <div class="suborder-item-list">
            <div class="suborder-item" v-for="orderItem in orderDetail.OrderItems" :key="orderItem.ItemId">              
              <router-link :to="'/retail/productDetail?skuId='+orderItem.SkuId">
                <img :src="orderItem.DetailImage?orderItem.DetailImage:IMGServer_URL+'/images/index-item-default.png'" onerror="this.src=IMGServer_URL+'/images/index-item-default.png'" class="order-img" />
                <div class="product-info" :style="{ width:suborderItemProductNameWidth+'px'}">
                  <p class="product-name">{{orderItem.ProductName}}</p>
                  <p class="attr">数量:{{orderItem.Quantity}} {{orderItem.Attribute}}</p>
                  <p class="price"><i class="fa fa-rmb"></i>{{orderItem.SalePrice.toFixed(2)}}</p>
                </div>   
              </router-link>           
            </div>
          </div>
        </div>
        <div class="order-detail" v-if="!loaded">
          <div class="order-info">
            <div class="field"><span>订单编号：</span>{{orderDetail.OrderNo}}</div>
            <div class="field"><span>下单时间：</span>{{orderDetail.Time.CreateDateName}}</div>
          </div>
          <div style="width:90%;height:1px;margin: 0px 10px;border-top:1px dashed #eee"></div>
          <div class="order-info">
            <div class="field"><span>支付方式：</span>{{orderDetail.OrderPay.PayTypeName}}</div>
            <div class="field"><span>支付时间：</span>{{orderDetail.Time.PayDateName}}</div>
          </div>
          <div style="width:90%;height:1px;margin: 0px 10px;border-top:1px dashed #eee"></div>
          <div class="order-info">
            <div class="field"><span>配送方式：</span>{{orderDetail.OrderDelivery.ShippingMethodName}}</div>
            <div class="field"><span>期望配送日期：</span>{{orderDetail.OrderDelivery.ShippingDateName}}</div>
          </div>
          <div style="width:90%;height:1px;margin: 0px 10px;border-top:1px dashed #eee"></div>
          <div class="order-info">
            <div class="field"><span>发票抬头：</span>{{orderDetail.InvoiceHead}}</div>
      </div>
    </div>

      </div>
    </div>
    
    <div class="order-detail" v-if="!loaded">  
      <div class="order-info">
        <div class="field">
          <span class="title">商品总额</span>
          <span class="num"><i class="fa fa-rmb"></i>{{orderDetail.OrderMoney.ProductMoney.toFixed(2)}}</span>
        </div>
        <div class="field">
          <span class="title">运费</span>
          <span class="num"><i class="fa fa-rmb"></i>{{orderDetail.OrderMoney.FreightMoney.toFixed(2)}}</span>
        </div>
        <div class="field">
          <span class="title">积分抵扣</span>
          <span class="num"><i class="fa fa-rmb"></i>{{orderDetail.OrderMoney.DiscountMoney.toFixed(2)}}</span>
        </div>
        <div class="summary">
          <span class="title">实付款:</span>
          <span class="num"><i class="fa fa-rmb"></i>{{orderDetail.OrderMoney.CashMoney.toFixed(2)}}</span>
        </div>
      </div>
    </div>
    <!-- <div class="operator" v-if="!loaded">
      <div class="button-list">
        <mu-raised-button label="发货" :to="'/salesman/delivery?orderNo='+orderDetail.OrderNo" class="button-item orderBtn receive" v-if="orderDetail.State == 3 || orderDetail.State == 4"></mu-raised-button>
      </div>
    </div>     -->
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fullWidth:document.documentElement.clientWidth,
      suborderItemProductNameWidth: (parseInt(document.documentElement.clientWidth)-105),
      loaded:true,
      orderDetail:{},
      siteConfig:{ MobileBgImage : '' }
    }
  },
  mounted(){
    this.$refs.XRtoast.load()
    this.getSiteInfo()
    this.getOrderDetail()
  },
  methods: {
    getSiteInfo: function () {    
        const ths = this;
        this.$post('/Shop/SiteConfigServer/GetSiteConfig')
            .then(function (res) {
            if(res.IsSuccess){
                ths.siteConfig = res.Data
            }         
        })
        .catch(function (err) {
            console.log(err)
        })    
    },      
    getOrderDetail(){     
      var ths = this;   
      ths.$post(
        "/Shop/RetailServer/GetOrderDetail",
        JSON.stringify({orderno: this.$route.query.orderNo})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.loaded =false
          ths.orderDetail = res.Data
          ths.$refs.XRtoast.hide()
        }
      });
    },
    orderConfrim(){      
      var ths = this;   
      ths.$post(
        "/Shop/RetailServer/OrderConfrim",
        JSON.stringify({OrderNos: [this.salesmanOrderdetailPage.OrderNo]})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.success(res.Msg, true)
          ths.getOrderDetail()
        }
      });
    },
    orderItemConfrim(itemId){
      var ths = this;   
      ths.$post(
        "/Shop/RetailServer/OrderItemConfrim",
        JSON.stringify({orderItemNos: [itemId]})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.success(res.Msg, true)
          ths.getOrderDetail()
        }
      });
    }
  }
}
</script>

<style>
#app .salesmanOrderdetailPage{
  background: #eee;
  bottom: unset;
  padding-bottom: 56px;
}
.salesmanOrderdetailPage .order-item .shopRow{
  background: white;
  overflow: hidden;
  color:#666;
  border-radius: 10px;
  width: 100%;
  padding: 15px 10px;
}
.salesmanOrderdetailPage .order-item .shopRow .all-chk{
  float: left;
  width: 40px;
  margin-top: 6px;
  text-align: center;
}
.salesmanOrderdetailPage .order-item .shopRow .shopName{
  padding-left: 10px;
  vertical-align: middle;
}
.salesmanOrderdetailPage .order-item .shopRow .shopName .shopLogo{
  float: left;
  width:20px;
  height: 20px;
  border-radius: 50%;
}
.salesmanOrderdetailPage .order-item .shopRow .shopName .shopNameValue{
  float: left;
  height: 20px;
  line-height: 20px;
  margin-left: 5px;
  font-size: 14px;
}
.salesmanOrderdetailPage .order-state{
  overflow: hidden;
  line-height: 60px;
  background: url(/static/us-top-bg.png);
  background-size: 100% 100%;
  color:white;
  padding-left: 15px;

}
.salesmanOrderdetailPage .hidden-scorll{background-color: #FCFCFC;}
.salesmanOrderdetailPage .delivery {
  overflow: hidden;
  background: white;
  padding:15px 10px;
  margin-top: 10px;
}
.salesmanOrderdetailPage .delivery .fa{  
  width: 30px;
  margin-top: 4px;
}
.salesmanOrderdetailPage .delivery .leftIcon {
  float:left;
}
.salesmanOrderdetailPage .delivery .rightIcon {
  float:right;
  text-align: center;
  margin-top: -23px;
}
.salesmanOrderdetailPage .delivery .delivery-process{
  overflow: hidden;
  padding-right: 40px;
}
.salesmanOrderdetailPage .delivery-process .text{
  font-size: 12px;
  color:#999;
  line-height: 16px;
  height: 32px;
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
}

.salesmanOrderdetailPage .order-delivery {
  overflow: hidden;
  background: white;
  padding:10px;
  margin-top: 10px;
}
.salesmanOrderdetailPage .order-delivery .fa {
  float:left;
  width: 30px;
  margin-top: 4px;
}
.salesmanOrderdetailPage .order-delivery .delivery-info{
  overflow: hidden;
}
.salesmanOrderdetailPage .order-delivery .delivery-info .member-info{
  overflow: hidden;
}
.salesmanOrderdetailPage .order-delivery .member-info .username{
  float: left;
}
.salesmanOrderdetailPage .order-delivery .member-info .mobile{
  float: left;
  margin-left: 14px;
}
.salesmanOrderdetailPage .order-delivery .address{
  font-size: 12px;
  color:#999;
}

.salesmanOrderdetailPage .order-list{
  overflow: hidden;
}
.salesmanOrderdetailPage .order-item{
  background: white;
  margin: 10px 0 0;
}
.salesmanOrderdetailPage .shoptip{
  overflow: hidden;
  background: white;
  padding:0 10px;
}
.salesmanOrderdetailPage .shoptip .shop-logo{
  float: left;
  line-height: 48px;
  height: 24px;
  margin: 12px 12px 12px 0;
}
.salesmanOrderdetailPage .shoptip .shop-name{
  float: left;
  line-height: 48px;
}
.salesmanOrderdetailPage .shoptip .state{
  float: right;
  line-height: 48px;
}

.salesmanOrderdetailPage .suborder-item-list{
  overflow: hidden;
  padding-left: 10px;
}
.salesmanOrderdetailPage .suborder-item{
  width:100%;
  overflow: hidden;
  padding: 20px 0;
}
.salesmanOrderdetailPage .suborder-item .order-img{
  width: 75px;
  height: 75px;
  object-fit: cover;
  float: left;
  padding: 1px;
  background: white;
}
.salesmanOrderdetailPage .mapIcon{
  float: left;
  width: 30px;
  line-height: 40px;
}
.salesmanOrderdetailPage .mapIcon img{
  width:100%;
  display: block;
  margin-top: 10px;
}
.salesmanOrderdetailPage .suborder-item .product-info{
  float: left;
  padding: 1px;
  margin-left: 10px;
  margin-right: 10px;
  word-break: break-all;
  height: 85px;
}
.salesmanOrderdetailPage .suborder-item .product-info .product-name{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 16px;
  font-size: 14px;
  padding-bottom: 10px;
  color:#333;
}
.salesmanOrderdetailPage .suborder-item .product-info .attr{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 14px;
  font-size: 12px;
  color:#999;
}
.salesmanOrderdetailPage .suborder-item .product-info .price{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 16px;
  font-size: 12px;
  margin-top: 24px;
  float: left;
}
.salesmanOrderdetailPage .suborder-item .product-info .item-button{
  float: right;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  margin-top: 6px;
  width: 60px;
  margin: 20px 0 0 0;
  padding:0;
  border: none;
  background: #f9f9f9;
  color:#999;
  border:1px solid #999;
  border-radius: 2px;
  margin-left: 10px;
  text-align: center;
}

.salesmanOrderdetailPage .order-total{
  overflow: hidden;
}
.salesmanOrderdetailPage .total-text{
  float: right;  
  font-size: 12px;
  line-height: 48px;
}
.salesmanOrderdetailPage .total-text span{
  font-size: 14px;
}

.salesmanOrderdetailPage .order-detail{
  border-radius: 10px;
  margin: 10px 0;
  background: white;
}
.salesmanOrderdetailPage .order-info {
  padding: 10px 0;
}
.salesmanOrderdetailPage .order-info .field{
  line-height: 24px;
  font-size: 12px;
  padding-left: 10px;
  padding-right: 10px;
  overflow: hidden;
  color:#999;
}
.salesmanOrderdetailPage .order-info .field span{
  color: #4D4A49;
}
.salesmanOrderdetailPage .order-info .field .title{
  float: left;
}
.salesmanOrderdetailPage .order-info .field .num{
  float: right;
  font-size: 14px;
}
.salesmanOrderdetailPage .order-info .fa{
  font-size: 12px;
}
.salesmanOrderdetailPage .order-info .summary{
  line-height: 16px;
  font-size: 16px;
  text-align: right;
  margin: 10px 0 0 10px;
  padding: 15px 10px 5px;
}
.salesmanOrderdetailPage .order-info .summary .num{
  color:red;
}


.salesmanOrderdetailPage .order-operator{
  overflow: hidden;
}
.salesmanOrderdetailPage .order-operator .button-list{
  float: right;
  padding: 10px 10px;
}

.salesmanOrderdetailPage .operator{  
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  background: #f9f9f9;
}
.salesmanOrderdetailPage .operator .button-list{
  float: right;
}
.salesmanOrderdetailPage .operator .button-list .button-item{
  height: 56px;
  background-color: rgb(244, 67, 54);
}
</style>



// WEBPACK FOOTER //
// src/pages/salesman/orderdetail.vue